import { styled } from '@mui/material'
import { IconThumbsDownOutline18 } from 'nucleo-ui-outline-18/components/IconThumbsDownOutline18'
import { IconThumbsUpOutline18 } from 'nucleo-ui-outline-18/components/IconThumbsUpOutline18'
import type { OMIconComponent } from '../types'

// The design sheet's filled thumbs fill the hand and keep the cuff as an outline, so only the hand's
// path is filled; its stroke stays so the shape matches the unselected one beside it.
const filledThumbSx = { '& path': { fill: 'currentColor' } }

export const ThumbsUpFilledOMIcon: OMIconComponent = styled(IconThumbsUpOutline18)(filledThumbSx)
export const ThumbsDownFilledOMIcon: OMIconComponent = styled(IconThumbsDownOutline18)(filledThumbSx)
